import { injectable } from 'inversify';
import { CommandHandler } from './command';

@injectable()
export class EmptyCommandHandler implements CommandHandler<any> {

  public async execute() {
  }

}
